import { REQUEST_BY_RESOLUTION } from '~/constants/enum'

export const useGetters = ({ i18n, device }) => {
  const $locale = () => i18n.locale
  const $language = () => i18n.locale === 'ua' ? 'uk' : 'ru'

  const $formFactor
    = () => device.isDesktop ? REQUEST_BY_RESOLUTION.DESKTOP : REQUEST_BY_RESOLUTION.MOBILE

  return {
    $locale,
    $language,
    $formFactor,
  }
}
